import React from "react";
// import { messages } from "../config/messages";
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Typography, FormHelperText } from "@mui/material";

const YesNoField = ({ label, value, onChange, required, helperText, yesLabel, noLabel }) => {
  const handleChange = (event) => {
    const val = event.target.value;

    if (val === "true") onChange(true);
    else if (val === "false") onChange(false);
    else onChange(null);
  };

  return (
    <FormControl  sx={{
        padding: 2,
        backgroundColor: "#eef2f6",
        borderRadius: 4,
      }}>
      <FormLabel required={required}>{label}</FormLabel>

      <RadioGroup
        // row
        value={
          value === true ? "true" :
          value === false ? "false" :
          ""
        }
        onChange={handleChange}

      >
        <FormControlLabel value="true" control={<Radio />} label={yesLabel} />
        <FormControlLabel value="false" control={<Radio />} label={noLabel} />
        <FormHelperText id="my-helper-text">{helperText}</FormHelperText>
      </RadioGroup>

    </FormControl>
  );
};

export default YesNoField;